import initData from 'init-data';
import { isNextJs, isServer } from 'tradera-utils/nextjs';

const getSiteBaseUrl = () =>
    isServer
        ? process.env.PUBLIC_TOUCHWEB_WINDOW_LOCATION_ORIGIN
        : window.location.origin;

const webApiUrl = isNextJs
    ? `${getSiteBaseUrl()}/api/webapi`
    : initData.webApiUrl;

const touchWebUrl = isNextJs ? `${getSiteBaseUrl()}/` : initData.touchWebUrl;

export default {
    AVAILABLE_SHIPPING_COUNTRIES:
        webApiUrl + '/member/getavailablecountriesforshipping',
    BANK_ID_AUTHENTICATE: touchWebUrl + 'bankid/authenticate',
    BANK_ID_PROGRESS: touchWebUrl + 'bankid/progress',
    BRAND_LIST_PAGE: touchWebUrl + 'brands/api',
    BRAND_PAGE: touchWebUrl + 'brand/api/',
    CAMPAIGN: campaignId =>
        touchWebUrl +
        'campaign/api/{campaignId}'.replace('{campaignId}', campaignId),
    CART_UPDATE_SUMMARY: touchWebUrl + 'shopping/managecart/updatecartsummary',
    CART_OVERVIEW_VIEW: webApiUrl + '/shopping/checkout/cartoverview',
    CART_ADD_ITEM: webApiUrl + '/shopping/cart/item',
    CART_REMOVE_ITEMS: webApiUrl + '/shopping/cart/removeitems',
    CART_SET_ITEM_QUANTITY: webApiUrl + '/shopping/cart/setitemquantity',
    CHARITY_EARNINGS_TICKER:
        touchWebUrl + 'cache/kampanjer/earningsticker/earnings',
    CMS_API: initData.cmsApiUrl,
    COMBINED_SHIPPING_UPSELL: touchWebUrl + 'combined-shipping-upsell/items',
    FAVORITE_SELLER_ADD: touchWebUrl + 'my/favourite-sellers/add',
    FAVORITE_SELLER_REMOVE: touchWebUrl + 'my/favourite-sellers/remove',
    FAVOURITE_SELLERS: webApiUrl + `/discover/favouritesellers-and-items2`,
    GET_PROFILE_FEEDBACK_ITEMS: touchWebUrl + 'profile/model',
    HYPERWALLET_PAYOUT_COMPLETE:
        webApiUrl + '/member/paymentprovider/completehyperwallettransfermethod',
    HYPERWALLET_PAYOUT_TOKEN:
        webApiUrl + '/member/paymentprovider/hyperwalletauthenticationtoken',
    HYPERWALLET_PAYOUT:
        webApiUrl +
        '/member/paymentprovider/hyperwallettransfermethodviewmodel',
    INTERNATIONAL_SHIPPING_CALCULATOR:
        webApiUrl + '/browse/internationalshippingcalculator',
    ITEM_DESCRIPTION: itemId =>
        `${webApiUrl}/browse/item/${itemId}/description`,
    ITEM_DISCOUNT_QUOTA: touchWebUrl + 'profile/shop-item-settings/quotas',
    LAST_CHANCE: touchWebUrl + 'StartPage/LastChance',
    MEMBER_PAYOUT_SETTINGS_REMOVE:
        webApiUrl + '/member/profile/removetraderapaypayoutdestination',
    MEMBER_PAYOUT_SETTINGS:
        webApiUrl + '/member/paymentprovider/memberpayoutsettingsviewmodel',
    MEMBER_SYSTEM_MESSAGES: webApiUrl + '/member/system-messages',
    ORDER_CHECKOUT_CONFIRMATION:
        webApiUrl +
        '/shopping/ordercheckout/purchaseordercheckoutconfirmationviewmodel',
    ORDER_CHECKOUT_PAYMENT: initData.orderCheckoutPaymentUrl,
    ORDER_CHECKOUT_REQUEST_COMBINED_PRICE:
        webApiUrl + '/shopping/ordercheckout/requestcombinedshippingprice',
    ORDER_CHECKOUT_CREATE_UNCOMMITTED_PURCHASE_ORDER:
        webApiUrl + '/shopping/ordercheckout/createuncommittedpurchaseorder',
    ORDER_PURCHASE_SHOP_ITEMS:
        webApiUrl + '/shopping/ordercheckout/purchaseshopitems',
    PAYMENT_SWISH_OPTOUT: touchWebUrl + 'my/payments2/OptOut',
    PERSONALISED_SUGGESTIONS: '/api/personalised-suggestions',
    SEARCH_SUGGESTIONS: touchWebUrl + 'search/suggestions',
    SEARCH: touchWebUrl + 'search',
    SELLING_CAMPAING_CODE: touchWebUrl + 'selling/api/campaign',
    SELLING_DRAFT_LOAD_FROM_TEMPLATE:
        touchWebUrl + 'selling/api/drafts/from-template',
    SELLING_DRAFT_SAVE: touchWebUrl + 'selling/api/drafts/',
    SELLING_DRAFT: draftId => touchWebUrl + `selling/api/drafts/${draftId}`,
    SELLING_DRAFTS_DELETE: touchWebUrl + 'selling/api/drafts/delete',
    SELLING_DRAFTS: touchWebUrl + 'selling/api/drafts/',
    SELLING_ITEM_PUBLISH: touchWebUrl + 'selling/api/items',
    SELLING_ITEM_STATUS: itemId =>
        touchWebUrl + `selling/api/items/${itemId}/status`,
    SELLING_ITEM_UPDATE: itemId =>
        touchWebUrl + `selling/api/items/${itemId}/update`,
    SELLING_PREVIEW: draftId =>
        touchWebUrl + `selling/api/drafts/preview/${draftId}`,
    SELLING_SCRIBE_DURATION: touchWebUrl + 'selling/api/scribe/duration',
    SELLING_SCRIBE_INCREMENT: touchWebUrl + 'selling/api/scribe/increment',
    SELLING_SCRIBE_SESSION_DURATION:
        touchWebUrl + 'selling/api/scribe/session-duration',
    SELLING_SCRIBE_SESSION_START:
        touchWebUrl + 'selling/api/scribe/session-start',
    SELLING_SCRIBE_VALIDATION_ERRORS:
        touchWebUrl + 'selling/api/scribe/form-validation-errors',
    SELLING_SHIPPING_CALCULATOR: touchWebUrl + 'selling/shippingcalculator',
    SELLING_TEMPLATE_SAVE: touchWebUrl + 'selling/api/templates',
    SELLING_TEMPLATE: templateId =>
        touchWebUrl + `selling/api/templates/${templateId}`,
    SELLING_TEMPLATES_COUNT: touchWebUrl + 'selling/api/templates-count',
    SELLING_TEMPLATES_DELETE: touchWebUrl + 'selling/api/templates/delete',
    SELLING_TEMPLATES: touchWebUrl + 'selling/api/templates',
    SETTINGS: touchWebUrl + 'profile/shop-item-settings/settings',
    SHIPPING_PROVIDERS: webApiUrl + '/selling/shippingproviderswithproducts',
    SWISH_APP2APP_CALLBACK: 'shopping/payment/swish',
    SWISH_APP2APP_CALLBACK_MARK_AS_PAID:
        webApiUrl + '/shopping/payment/swish-app2app-paymentcallback',
    TOUCHWEB_URL: touchWebUrl,
    TRANSLATE_PROFILE_FEEDBACKITEMS: webApiUrl + '/member/feedback/translated',
    WEB_API: webApiUrl,
    WISHLIST: touchWebUrl + 'my/api/wish-list',
    WISHLIST_ADD: touchWebUrl + 'shopping/wishlist/add',
    WISHLIST_REMOVE: touchWebUrl + 'shopping/wishlist/remove',
    START_OFF_PLATFORM_CHECKOUT:
        touchWebUrl + 'shopping/cartoverview/StartCheckoutSession',
    UPI: purchaseOrderId =>
        webApiUrl + '/member/uppo-strike/?PurchaseOrderId=' + purchaseOrderId,
    INR: purchaseOrderId =>
        webApiUrl + '/member/ponr-strike/?PurchaseOrderId=' + purchaseOrderId,
    PURCHASE_ORDER: purchaseOrderId =>
        webApiUrl + '/member/purchaseorder/?PurchaseOrderId=' + purchaseOrderId,
    MARKETING_PUBLIC_API: '/api/marketing',
    SHIPPING_CHECKOUT_DELETE: '/my/shipping/checkout/delete'
};
